module.exports = __webpack_public_path__ + "media/news/berlin-news-01-2f9d3979.webp";